import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { JobCategory } from '@app/core/models/cateogory';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-ac-chips-material',
    templateUrl: './ac-chips-material.component.html',
    styleUrls: ['./ac-chips-material.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AcChipsMaterialComponent),
            multi: true
        }
    ]
})
export class AcChipsMaterialComponent implements OnInit {
    _value: JobCategory[] = [];
    results: JobCategory[];
    @Input() suggestions: JobCategory[];
    @Input() title: string;
    @Input() key: string;
    @Input() set setSuggestions(v) {
        if (v) {
            this.catInput.nativeElement.value = '';
            this.catInput.nativeElement.blur();
            this.fruitCtrl.setValue(null);
            this.onValueChange.next(this.suggestionsCopy);
        }
    }
    @Input() disabled;
    suggestionsCopy = [];
    visible = true;
    selectable = true;
    removable = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    fruitCtrl = new FormControl();
    filteredProds: Observable<any[]>;
    @Output() public onValueChange = new EventEmitter<any[]>();
    @Output() public onAddNewLocation = new EventEmitter<boolean>();
    @ViewChild('catInput') catInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    constructor() {}

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        if ((value || '').trim()) {
            const item = this.suggestions.find((s) => {
                return s.id === value;
            });
            if (item) {
                this.suggestionsCopy.push(value.trim());
            }
        }

        if (input) {
            input.value = '';
        }

        this.fruitCtrl.setValue(null);
        this.onValueChange.next(this.suggestionsCopy);
    }

    remove(suggestion: any): void {
        const index = this.suggestionsCopy.indexOf(suggestion);

        if (index >= 0) {
            this.suggestionsCopy.splice(index, 1);
        }
        this.onValueChange.next(this.suggestionsCopy);
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        if (event.option.value.id === '#location') {
            this.onAddNewLocation.next(true);
        } else {
            this.suggestionsCopy.push(event.option.value);
        }
        this.catInput.nativeElement.value = '';
        this.catInput.nativeElement.blur();
        this.fruitCtrl.setValue(null);
        this.onValueChange.next(this.suggestionsCopy);
    }

    private _filter(value): JobCategory[] {
        if (!value) {
            return this.suggestions;
        }
        if (typeof value === 'string') {
            value = value.toLowerCase();
        }
        const filterValue = value;
        return this.suggestions.filter((suggestion) => {
            // console.log(suggestion);
            return suggestion && suggestion.name.toLowerCase().indexOf(filterValue) === 0;
        });
    }

    ngOnInit(): void {
        /* tslint:disable */
        this.filteredProds = this.fruitCtrl.valueChanges.pipe(
            startWith(null),
            map((cat: JobCategory | null) => (cat ? this._filter(cat) : this.suggestions.slice()))
        );
        /* tslint:enable */
    }

    writeValue(value: any) {
        if (value !== undefined && Array.isArray(value)) {
            // console.log('VALUE PASSED TO COMPONENT:', value);

            const values = [];

            value.forEach((v) => {
                const item = this.suggestions.find((s) => {
                    return s.id === v;
                });
                if (item) {
                    values.push(item);
                }
            });
            this.suggestionsCopy = values;
        }
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    triggerChange(event) {
        this.changeValue(this._value);
    }

    changeValue(val) {
        this.onValueChange.next(val);
        const modelValues = val.map((v) => v.id);
        this.propagateChange(modelValues);
    }
}
